import { MetadataStore, Validator } from 'breeze-client';
import { notEmptyGuidValidator } from './not-empty-guid-validator';
import { notNullOrUndefinedValidator } from './not-null-or-undefined-validator';

export const registerValidators = (_: MetadataStore) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  Validator.register(notNullOrUndefinedValidator), Validator.register(notEmptyGuidValidator);
};
